module.exports = __webpack_public_path__ + "img/bukalapak@2x.98c4662f.png";